import axios from 'axios';

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';

const preprodAPI = 'http://127.0.0.1:8000';
const prodAPI = 'https://api.fuzzcv.com';
let apiURL = ''

if(process.env.NODE_ENV === 'production') {
  apiURL = prodAPI;
}
else {
  apiURL = preprodAPI;
}


const session = axios.create({
  // development
  // baseURL: 'http://127.0.0.1:8000',
  // prod
  baseURL: apiURL,
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
});

export default session;
